export default "__VITE_ASSET__440231bc__"